import './App.css';
import React, { Fragment, useEffect, useState } from "react";
import { Unity, useUnityContext } from "react-unity-webgl";

function App() {
  const [showModal, setShowModal] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const container = document.querySelector("#unity-container");
    if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
      container.className = "unity-mobile";
      setShowModal(false);
      setIsMobile(false);
    } else {
      setIsMobile(false);
    }
  }, []);

  const { unityProvider, loadingProgression, isLoaded } = useUnityContext({
    loaderUrl: "Build/WEBGL.loader.js",
    dataUrl: "Build/WEBGL.data",
    frameworkUrl: "Build/WEBGL.framework.js",
    codeUrl: "Build/WEBGL.wasm",
    streamingAssetsUrl: "StreamingAssets",
    companyName: "BRRCS RECORDS",
    productName: "Astroflip",
    productVersion: "0.1",
  });

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <div className="App">
      {showModal && isMobile && (
        <div className="modal">
          <div className="modal-content">
            <span className="close-button" onClick={closeModal}>&times;</span>
            <h2>Please use a PC or Laptop</h2>
            <p>This application is best experienced on a desktop device. Please access it from a PC or laptop.</p>
          </div>
        </div>
      )}
      {!isMobile && (
        <div id="unity-container" className="unity-desktop">
          <canvas id="unity-canvas"></canvas>
          <Fragment>
            <div className="container">
              <img style={{ width: 90, marginTop: -500 }} src="./brrbounce.gif" alt="Brian Bouncing GIF" />
              {!isLoaded && (
                <div className="loading-bar">
                  <div className="filler" style={{ width: `${loadingProgression * 100}%` }} />
                  <p className="loading-text">Loading... {Math.round(loadingProgression * 100)}%</p>
                </div>
              )}
            </div>
            <Unity
              style={{
              
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            visibility: isLoaded ? "visible" : "hidden"
          }} Unity unityProvider={unityProvider} width="100%" height="100%"
            />

          </Fragment>
        </div>
      )}
    </div>
  );
}

export default App;
